<template>
  <div class="container">
    <h1 class="subs-title">{{ id ? adminText('organizationAll.update_a_subscriber_fea34ef9', 'Update a subscriber') : adminText('organizationAll.create_a_subscriber_04ea14e0', 'Create a subscriber') }}</h1>
    <div v-if="loading">
      <span class="page-title"> {{ adminText('organizationAll.loading_b04ba49f', 'Loading...') }} </span>
    </div>
    <subscription-form
      v-else
      :schema="schema"
      :initial-values="subscription"
      :organization-slug="organizationSlug"
      :submitting="submitting"
      :initial-prepaid-coupon-id="initialPrepaidCouponId"
      @onCreate="handleCreate"
      @onUpdate="handleUpdate"
    />
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { GET_ORGANIZATION_BY_SLUG } from '@/graphql/organization.graphql'
import { createAttendeeSchema } from '@/utils'
import SubscriptionForm from '@/components/organizations/subscriptions/forms/SubscriptionForm.vue'
import {
  CREATE_SPORT_MEMBERSHIP_PREPAID_USER,
  GET_PREPAID_COUPON_USER_BY,
  GET_PREPAID_COUPON_USER_BY_ID,
  UPDATE_SPORT_PREPAID_COUPON_USER,
} from '@/graphql/prepaidCouponUser.graphql'

export default {
  mixins: [OrganizationLocalization],
  name: 'subscription-container',
  components: { SubscriptionForm },
  props: {
    id: {
      type: String,
      default: null,
    },
    organizationSlug: {
      type: String,
    },
    initialPrepaidCouponId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      subscription: null,
      schema: {},
      loading: true,
      submitting: false,
    }
  },
  async mounted() {
    await this.getOrganization()
    if (this.id) {
      await this.getSubscription(this.id)
    }
  },
  methods: {
    async handleCreate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: CREATE_SPORT_MEMBERSHIP_PREPAID_USER,
        variables: {
          dto: this.mapFormData(form),
          organizationSlug: this.organizationSlug,
        },
      })
      this.$router.go(-1)
      this.submitting = false
    },
    async getOrganization() {
      const { data } = await this.$apollo.query({
        query: GET_ORGANIZATION_BY_SLUG,
        variables: { organizationSlug: this.organizationSlug },
      })

      if (data) {
        this.organization = data.getOrganizationBySlug
        if (this.organization.attendeeFields.subscriptionFields) {
          this.schema = createAttendeeSchema(this.organization.attendeeFields.subscriptionFields)
        }
      }

      this.loading = false
    },
    mapFormData(data) {
      let payload = {
        fields: {},
      }

      Object.keys(data).forEach(key => {
        if (key === 'prepaidCouponId') {
          Object.assign(payload, { [key]: data[key] })
        } else {
          Object.assign(payload.fields, { [key]: data[key] })
        }
      })

      return payload
    },

    async getSubscription(id) {
      this.loading = true
      const {
        data: { getPrepaidCouponUserById: subscription },
      } = await this.$apollo.query({
        query: GET_PREPAID_COUPON_USER_BY_ID,
        variables: {
          organizationSlug: this.organizationSlug,
          id,
        },
      })

      this.subscription = { ...subscription, prepaidCouponId: Number(subscription.prepaidCouponId) }
      this.loading = false
    },

    async handleUpdate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: UPDATE_SPORT_PREPAID_COUPON_USER,
        variables: {
          organizationSlug: this.organizationSlug,
          id: this.id,
          dto: this.mapFormData(form),
        },
      })

      this.$router.go(-1)
      this.submitting = false
    },
  },
}
</script>
<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
  row-gap: 2rem;
}

.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
